import { ACTIVITY_PAGE_TYPE } from 'lib/_types'
import { ContextSchema, SchemaDetail, schemaPath } from './types'

// Schema for Notification
const NOTIFICATION_SCHEMA: SchemaDetail = {
  vendor: 'space.yay',
  name: 'notification',
  format: 'jsonschema',
  version: '1-0-0',
}

export type NotificationContextSchemaData = {
  type: ACTIVITY_PAGE_TYPE // Type of notifcation
  user_id?: number // User Id of the user who trigger this notification
  is_follow_by_viewer?: boolean // cating if this user follows the viewer
  is_viewer_follow?: boolean // ndicating if the viewer follows this user
  last_visit?: string // plicable for Footprint Type only. Timestamp of the last visit shown on Footprint screen
}

export const notificationContextSchema = (
  data: NotificationContextSchemaData
): ContextSchema<NotificationContextSchemaData> => ({
  schema: schemaPath(NOTIFICATION_SCHEMA),
  data,
})
